import { isPlainObj } from "../aide";

// Returns a new object from the one provided, where the entries are sorted by key (deterministic)
export const sortKeys = obj =>
  Object.keys(obj || {})
    .sort()
    .reduce((result, key) => {
      result[key] = isPlainObj(obj[key]) ? sortKeys(obj[key]) : obj[key];
      return result;
    }, {});
